module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/win10-start-light-bgimage.f7c765f8.svg";